import { ClientTypeEnum } from '@ulysses-inc/harami_api_client'
import { appMode, getAppVersion } from '~/config'

const appVersionHeaderName = 'Kmns-Harami-Report-Version'
const appVersion = getAppVersion()

// アプリの動作モード (kiosk / app) を API サーバーに宣言するヘッダー。
// kiosk / app のアプリは同一の API ホストを共有しており、ブラウザは片方のモードで確立した
// セッション Cookie をもう片方のモードのリクエストにも付与してしまう。API サーバーはこの
// ヘッダーの値に応じて参照するセッション Cookie (harami_sid / harami_device_sid) を切り替える
// ことで、意図しない認証状態になることを防ぐ。
const appModeHeaderName = 'Kmns-Harami-Report-App-Mode'

export const getAppModeHeader = () => {
  return { [appModeHeaderName]: appMode.isKiosk ? 'kiosk' : 'app' }
}

export const getHeaders = () => {
  return {
    ct: `${ClientTypeEnum.MOBILE}`,
    locationHref: `${location.href}`,
    [appVersionHeaderName]: appVersion,
    ...getAppModeHeader(),
  }
}
